import { createTheme } from "@material-ui/core/styles";
import { CustomTheme } from "./CustomThemeInterface";
import { customValues } from "./CustomThemeValues";

// TODO: figure out a better way of adding custom values to the theme
declare module "@material-ui/core/styles/createTheme" {
    interface Theme extends CustomTheme {}
    // allow configuration using `createTheme`
    interface ThemeOptions extends CustomTheme {}
}

export const theme = createTheme({
    ...customValues,
    palette: {
        background: {
            default: customValues.colors.neutrals.white,
        },
        text: {
            primary: customValues.colors.neutrals.neutral600,
        },
    },
    overrides: {
        MuiPopover: {
            root: {
                // marginRight: "calc(-1 * (100vw - 100%))",
                // overflowX: "hidden",
            },
        },
    },

    // TODO: add remaining typography from the Verge Design System
    typography: {
        fontSize: 16,
        fontFamily: "'canada-type-gibson', 'sans-serif'",
        h1: {
            fontSize: "41px",
            lineHeight: "41px",
        },
        h2: {
            fontSize: "32px",
            lineHeight: "32px",
        },
        h3: {
            fontSize: "28px",
            lineHeight: "28px",
        },
        h4: {
            fontSize: "24px",
            lineHeight: "120%",
            fontWeight: 600,
        },
        h5: {
            fontSize: "18px",
            lineHeight: "18px",
            fontWeight: 600,
        },
        h6: {
            // Isn't defined in the Verge Design System
            // Using values for Body Copy
            fontSize: "12px",
            lineHeight: "12px",
            fontWeight: 400,
        },
        // Body Copy
        body1: {
            fontSize: "16px",
            lineHeight: "24px",
        },
        // Body Copy Small
        body2: {
            fontSize: "14px",
            lineHeight: "118%",
        },
        subtitle1: {
            fontSize: "14px",
            lineHeight: "120%",
        },
        // Same as Fine Print
        subtitle2: {
            fontSize: "12px",
            lineHeight: "12px",
            fontWeight: 400,
        },
        caption: {
            fontSize: "10px",
            lineHeight: "10px",
            textTransform: "uppercase",
        },
        button: {
            fontSize: "16px",
            lineHeight: "16px",
            textTransform: "none",
        },
    },

    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
});
